import CardDiv from "modules/common/card-div/CardDiv";
import ActionableCustomerList from "modules/dashboards/actionable_list/ActionableCustomerList";
import React, { useEffect, useMemo, useState } from "react";
import { useIVREngagements } from "./store";
import PaginationDiv from "modules/pagination/PaginationDiv";
import moment from "moment";
import useActionableListStore from "modules/dashboards/actionable_list/store";
import { currentUser, getCurrentUserRole, LEAD_AGENT_ACTIONABLE_FLAG } from "modules/utilities/utility";
import DatePicker from "react-datepicker";
import CardTabs from "modules/common/card-tabs/CardTabs";
import { paginationData } from "modules/engagement_report/engagement_reports/engagement_cf";
import { RECEPTIONINST } from "modules/utilities/utility_2";

function TodayEngagement() {
    const { fetchIVRBooking, IVRBookingData, IVRLoading } = useIVREngagements();
    const [userData, setUserData] = useState([]);
    const [page, newPage] = useState(1);
    const [filterData, setFilter] = useState([]);
    const [pageCount, setPageCount] = useState(1);
    const [leadPage, leadNewPage] = useState(1);
    const [leadFilterData, setLeadFilter] = useState([]);
    const [leadPageCount, setLeadPageCount] = useState(1);
    const [attemptPage, attemptNewPage] = useState(1);
    const [attemptFilterData, setAttemptFilter] = useState([]);
    const [attemptPageCount, setAttemptPageCount] = useState(1);
    const [showCustomerInFull, setShowCustomerInFull] = useState(false);
    const start = moment().subtract(14, "days").startOf("day").toISOString();
    const end = moment().endOf("day").toISOString();
    const [startDate, setStartDate] = useState(
        moment().startOf("day").subtract(14, "days").toDate()
    );
    const [endDate, setEndDate] = useState(moment().endOf("day").toDate());
    const {
        todayEngData,
        todayLoading,
        fetchTodayEngData,
        fetchTempEngData,
        fetchLeadTempData,
        tempLeadData,
        tempEngData,
    } = useActionableListStore();
    const [submitFlag, setSubmitFlag] = useState(0);
    const [leadUserData, setLeadUserData] = useState([]);
    const [reAttempt, setReAttempt] = useState([]);
    const leadAgent = ["lead_agent"];
    const agent = ["sales", "lead_agent"];
    const med = ["medical"];

    useEffect(() => {
        if (agent.includes(getCurrentUserRole())) {
            fetchTodayEngData();
            fetchLeadTempData();
        } else if (med.includes(currentUser) && startDate && endDate) {
            fetchIVRBooking(startDate, endDate);
        } else if (RECEPTIONINST) {
            fetchTodayEngData();
            fetchTempEngData();
        } else {
            fetchIVRBooking(start, end);
        }
    }, [submitFlag]);

    useEffect(() => {
        if (agent.includes(getCurrentUserRole())) {
            if (["lead_agent"].includes(currentUser)) {
                const allUserData = [...todayEngData, ...tempLeadData];
                const filterColdCall = allUserData?.filter((item) => (
                    item.request_type !== "lead_cold_slot" &&
                    (item?.unanswered_count === 0 && item?.reschedule_count === 0 || item?.unanswered_count !== item?.reschedule_count)
                ));
                const leadCall = allUserData?.filter((item) => item.request_type == "lead_cold_slot");
                const reAttemptData = allUserData?.filter((item) => item?.unanswered_count > 0 && item?.reschedule_count > 0);
                const sortByReminderDate = (data) => {
                    return [...data].sort((dateOne, dateTwo) => new Date(dateTwo?.reminder_date) - new Date(dateOne?.reminder_date));
                };

                setReAttempt(sortByReminderDate(reAttemptData));
                setUserData(sortByReminderDate(filterColdCall));
                setLeadUserData(sortByReminderDate(leadCall));
            } else {
                setUserData(todayEngData);
            }
        } else if (RECEPTIONINST){
            setUserData([...todayEngData, ...tempEngData]);
        } else if(['chat_call_agent'].includes(currentUser)){
            setUserData(todayEngData);
        } else {
            setUserData(IVRBookingData);
        }
    }, [IVRBookingData, todayEngData, tempLeadData]);

    useEffect(() => {
        async function calculate() {
            paginationData(leadUserData, setLeadPageCount, setLeadFilter, leadPage);
        }
        !_.isEmpty(leadUserData) && calculate();
    }, [leadUserData, leadPage]);

    useEffect(() => {
        async function calculate() {
            paginationData(userData, setPageCount, setFilter, page);
        }
        !_.isEmpty(userData) && calculate();
    }, [userData, page]);

    useEffect(() => {
        async function calculate() {
            paginationData(reAttempt, setAttemptPageCount, setAttemptFilter, attemptPage);
        }
        !_.isEmpty(reAttempt) && calculate();
    }, [reAttempt, attemptPage]);

    const handleSubmit = () => {
        setSubmitFlag(submitFlag + 1);
    };

    const handleClear = () => {
        setStartDate(moment().startOf("day").subtract(14, "days").toDate());
        setEndDate(moment().endOf("day").toDate());
        setSubmitFlag(submitFlag + 1);
    };

    const loading = agent.includes(getCurrentUserRole())
        ? todayLoading
        : IVRLoading;

    const CustomerSlotComponents = {
        "slot booking": (
            <div className="mt-n3 ms-n3">
                <ActionableCustomerList
                    actionableData={filterData}
                    actionableTabs={true}
                    actionableLoading={loading}
                    showCustomerInFull={showCustomerInFull}
                    setShowCustomerInFull={setShowCustomerInFull}
                />
                <div className="mt-n5" style={{ width: "30%" }}>
                    {!showCustomerInFull ? (
                        <PaginationDiv
                            newPage={newPage}
                            paginationData={{ pageCount: pageCount || 1, page: page }}
                        />
                    ) : null}
                </div>
            </div>
        ),
        "cold call": (
            <div className="mt-n3 ms-n3">
                <ActionableCustomerList
                    actionableData={leadFilterData}
                    actionableTabs={true}
                    actionableLoading={loading}
                    showCustomerInFull={showCustomerInFull}
                    setShowCustomerInFull={setShowCustomerInFull}
                />
                <div className="mt-n5" style={{ width: "30%" }}>
                    {!showCustomerInFull ? (
                        <PaginationDiv
                            newPage={leadNewPage}
                            paginationData={{ pageCount: leadPageCount || 1, page: leadPage }}
                        />
                    ) : null}
                </div>
            </div>
        ),
        "reattempt": (
            <div className="mt-n3 ms-n3">
                <ActionableCustomerList
                    actionableData={attemptFilterData}
                    actionableTabs={true}
                    actionableLoading={loading}
                    showCustomerInFull={showCustomerInFull}
                    setShowCustomerInFull={setShowCustomerInFull}
                />
                <div className="mt-n5" style={{ width: "30%" }}>
                    {!showCustomerInFull ? (
                        <PaginationDiv
                            newPage={attemptNewPage}
                            paginationData={{ pageCount: attemptPageCount || 1, page: attemptPage }}
                        />
                    ) : null}
                </div>
            </div>
        ),
    };

    return (
        <div>
            <CardDiv
                title={
                    med.includes(currentUser) ? (
                        <div className="d-flex justify-content-between">
                            <div>Medicals Engagement</div>
                            <div className="d-flex gap-2" style={{ zIndex: "999" }}>
                                <DatePicker
                                    selected={startDate}
                                    onChange={(date) => setStartDate(date)}
                                    formatWeekDay={(day) => day.slice(0, 3)}
                                    className="form-control"
                                    placeholderText="Select previous Date"
                                />
                                <DatePicker
                                    selected={endDate}
                                    onChange={(date) => setEndDate(date)}
                                    formatWeekDay={(day) => day.slice(0, 3)}
                                    className="form-control"
                                    placeholderText="Select previous Date"
                                />
                                <button
                                    className="btn btn-primary"
                                    style={{ height: "2.26rem" }}
                                    onClick={handleSubmit}
                                >
                                    Submit
                                </button>
                                <button
                                    className="btn btn-primary"
                                    style={{ height: "2.26rem" }}
                                    onClick={handleClear}
                                >
                                    Clear
                                </button>
                            </div>
                        </div>
                    ) : (
                        "Today Engagements"
                    )
                }
                component={
                    ((userData && userData.length > 0) ||
                    (leadUserData && leadUserData.length > 0) ||
                    (reAttempt && reAttempt.length > 0)) ? (
                        leadAgent.includes(currentUser) ? (
                            <div>
                                <CardTabs components={CustomerSlotComponents} />
                            </div>
                        ) : (
                            <>
                                <ActionableCustomerList
                                    actionableData={filterData}
                                    actionableTabs={true}
                                    actionableLoading={loading}
                                    showCustomerInFull={showCustomerInFull}
                                    setShowCustomerInFull={setShowCustomerInFull}
                                />
                                <div className="mt-n5" style={{ width: "30%" }}>
                                    {!showCustomerInFull ? (
                                        <PaginationDiv
                                            newPage={newPage}
                                            paginationData={{ pageCount: pageCount || 1, page: page }}
                                        />
                                    ) : null}
                                </div>
                            </>
                        )
                    ) : (
                        <div>No engagements available</div> // Fallback message when no data is present
                    )
                }
            />
        </div>
    );
}

export default TodayEngagement;